import React from 'react';

const VerParam1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd}) => {
  const a254001 = autorizacUA.findIndex( autorizac => autorizac === "254001" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a254001!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerParam1
